import type { RouterUseMutationOptions } from '@newfront-insurance/data-layer-client';

import { useAdminTRPC } from '../../../shared/providers/trpc';
import type { SharedRouter } from '../../../shared/trpc/router';

export function useArchiveFile(options: RouterUseMutationOptions<SharedRouter, 'files.archiveFile'>) {
  const { useMutation } = useAdminTRPC();

  return useMutation('files.archiveFile', options);
}
